export default {
    
    messages: [
        { text: 'この研究室を選んだ理由を教えてください', type: 'bot' },
        { text: '対話システムに興味があったから。先生が優しそうだったから。', type: 'user' },
        { text: '自然言語処理で感性についての研究を行っているから。', type: 'user' },
        { text: '研究室の規模（先生や学生の人数や研究分野の多様さ）', type: 'user' },
        { text: '3年の時に研究室紹介を聴講して、雰囲気が良かったから', type: 'user' },
        { text: 'この研究室の雰囲気を一言で表すと何？', type: 'bot' },
        { text: '自由', type: 'user' },
        { text: '平和', type: 'user' },
        { text: '会社のオフィス', type: 'user' },
        { text: '多様', type: 'user' },
        { text: 'この研究室の長所を教えてください', type: 'bot' },
        { text: '研究費がわりとある？ので研究のための機材が揃っている、なければ買ってくれる', type: 'user' },
        { text: '自由な研究ができるみんな優しい。', type: 'user' },
        { text: 'わからないことがあっても相談しやすい', type: 'user' },
        { text: '進捗を毎週確認し、アドバイスや指摘をきちんとしてくれる点', type: 'user' },
        { text: 'この研究室に入ってよかったこと，面白かったことは？', type: 'bot' },
        { text: '研究が行き詰まっても、先生方から具体的な提案や意見をいただけた点。発表練習がかなりの頻度で行われる点。', type: 'user' },
        { text: '高価なサーバやロボットを触れたこと', type: 'user' },
        { text: '先生方も含め，性格があう人たちに出会えたこと', type: 'user' },
        { text: '自由度が高く、研究したいことを尊重してくれるかつ就職活動等自分の予定を組み込みやすいこと', type: 'user' },
        { text: '研究室に入って大変だったことは？', type: 'bot' },
        { text: '研究に意義を見出すところ。', type: 'user' },
        { text: '高級品の使い道を考えろと言われたこと', type: 'user' },
        { text: '毎週の進捗報告、進捗が無かったときは報告するのが辛い', type: 'user' },
        { text: '学会に出るための資料作成や論文作成', type: 'user' },
        { text: 'どんな人に来てほしいですか？', type: 'bot' },
        { text: '主体性のある人，修士に行きたい人', type: 'user' },
        { text: '研究室によく来てくれる子', type: 'user' },
        { text: '何をするか決まってない人でも、内容に少しでも興味がある人', type: 'user' },
        { text: '言語系で何となくやりたい方向性が決まっている人。きっちり返信•質問が必要な時にできる人', type: 'user' },
      ],
}
